import { useQuery } from "@tanstack/react-query";

import { GO_HIRE_QUERY_KEYS } from "../queryKeys";
import { getTalentHeatmap } from "../services/job.services";

export const useGetTalentHeatmap = () => {
  return useQuery({
    queryKey: GO_HIRE_QUERY_KEYS.talentHeatmap(),
    queryFn: getTalentHeatmap,
  });
};
